module.exports = __webpack_public_path__ + "img/tax-invoice-logo.49e3803e.png";